/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

// @ts-nocheck TS2339
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  width: 100%;
  min-width: 0;
  min-height: 0;
  height: 100%;
`;

export const LeftPanel = styled.div`
  flex: ${({ $isFullWidth }) => ($isFullWidth ? '1' : '0 0 60%')};
  display: flex;
  flex-direction: column;
  min-width: 0;
  min-height: 0;
  background-color: var(--cds-ui-01, #ffffff);
  border-right: 1px solid var(--cds-border-subtle-01, #e0e0e0);
`;

export const RightPanel = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
  min-height: 0;
  background-color: var(--cds-ui-01, #ffffff);
`;

export const PdfWrapper = styled.div`
  flex: 1;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--cds-text-secondary);
  min-width: 0;
`;
